// extracted by mini-css-extract-plugin
export default {"searchBox":"googleAutoComp_searchBox__XFBH4","closeBtn":"googleAutoComp_closeBtn__9dzdJ"};